import React, { useEffect, useState } from 'react';
import { Box, Heading, Tabs, TabList, Tab, Flex } from '@chakra-ui/react';
import Page from '../components/ui/Page';
import SectionCard from '../components/ui/SectionCard';
import SettingsApiKeysTab from '../components/SettingsApiKeysTab';
import SettingsUsersTab from '../components/SettingsUsersTab';
import SettingsProjectsTab from '../components/SettingsProjectsTab';
import ProfileTab from './ProfilePage';
import { useSearchParams } from 'react-router-dom';

function SettingsPage() {
  const tabNames = ['profile', 'api', 'users', 'projects'];
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get('tab');
  const initialIndex = Math.max(0, tabNames.indexOf((initialTab || '').toLowerCase()));
  const [tabIndex, setTabIndex] = useState(initialIndex);

  useEffect(() => {
    const qp = searchParams.get('tab');
    const idx = Math.max(0, tabNames.indexOf((qp || '').toLowerCase()));
    if (idx !== tabIndex) setTabIndex(idx);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const handleChange = (index) => {
    setTabIndex(index);
    const next = new URLSearchParams(searchParams);
    next.set('tab', tabNames[index]);
    setSearchParams(next, { replace: true });
  };
  return (
    <Page>
      <Flex direction="column">
        <Heading mb={6} fontWeight="bold" size="lg">Settings</Heading>
        <SectionCard p={{ base: 2, md: 8 }}>
          <Tabs variant="enclosed" colorScheme="green" isFitted index={tabIndex} onChange={handleChange}>
            <TabList mb={4}>
              <Tab>Profile</Tab>
              <Tab>API Keys</Tab>
              <Tab>Users</Tab>
              <Tab>Projects</Tab>
            </TabList>
          </Tabs>
          <Box mt={4}>
            {tabIndex === 0 && <ProfileTab />}
            {tabIndex === 1 && <SettingsApiKeysTab />}
            {tabIndex === 2 && <SettingsUsersTab />}
            {tabIndex === 3 && <SettingsProjectsTab />}
          </Box>
        </SectionCard>
      </Flex>
    </Page>
  );
}

export default SettingsPage; 